import React, { PropsWithChildren } from "react";

type PropTypes = PropsWithChildren<{
  on: boolean | undefined;
}>;

export const ConditionalRender: React.FC<PropTypes> = ({ on, children }) => {
  if (!on) return null;
  return <>{children}</>;
};
